<template>
  <FormItem :label="model.variable.label" :inline="inline">
    <CheckboxGroup v-model="newVal" @on-change="changeVal">
      <Checkbox :label="'' + key" v-for="(code, key) in model.variable.codes" :key="key">
        {{ code }}
      </Checkbox>
    </CheckboxGroup>
  </FormItem>
</template>

<script>
export default {
  name: 'checkbox-element',
  data: function () {
    return {
      newVal: this.model.val ? this.model.val.split(',') : []
    }
  },
  // watch: {
  //   'val': function () {
  //     this.newVal = this.val.val ? this.val.val.split(',') : []
  //   }
  // },
  props: ['model', 'inline'],
  methods: {
    changeVal: function (value) {
      this.model.val = this.newVal.join(',')
      // this.$emit('editVal', this.model, this.newVal.join(','))
    }
  }
}
</script>
